import {
  Accordion,
  Box,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const StyledAccordion = styled(Accordion)`
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border: none;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  height: auto;
`

export const AccordionContent = styled(Box)`
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  padding-top: ${({ theme }) => getThemeSpacing(3, theme)};
  border-top: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  flex-direction: column;
  width: 100%;
  flex: 1;
`

export const ItemCard = styled(Box)`
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  gap: ${({ theme }) => getThemeSpacing(2, theme)};
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;

  a {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => getThemeSpacing(2, theme)};
  }
`

export const IconContainer = styled(Box)`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
  background-color: ${({ theme }) => getThemeColor('grey_5', theme)};
  justify-content: center;
  align-items: center;
`
